
<template>
  <el-select-tree
    v-model="selectValue"
    v-bind="$attrs"
    :options="options"
    :default-props="defaultProps"
    :is-leaf="isLeaf"
    :filterable="filterable"
    v-on="$listeners"
  />
</template>

<script>
import { choseOrganOrganTreeData, busContractorUserOrgan } from '@/api/common'
export default {
  name: 'UmBusOrgan',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    filterable: {
      type: Boolean,
      default: true
    },
    organType: {
      type: Array,
      default: () => [1, 2, 3, 4]
    },
    organNature: {
      type: Array,
      default: () => [0, 1]
    },
    value: {
      type: [Array, Number, String],
      default: null
    },
    busContractorId: {
      type: [Number, String],
      default: null
    },
    isLeaf: {
      type: Boolean,
      default: false
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          value: 'busOrganId',
          label: 'organName',
          children: 'children',
          selectlabel: 'organFullName'
        }
      }
    }
  },
  data() {
    return {
      options: []
    }
  },
  computed: {
    selectValue: {
      get() {
        if (this.value === null) {
          return null
        }
        if (Array.isArray(this.value)) {
          return this.value.map((item) => parseInt(item))
        }
        if (isNaN(parseInt(this.value))) {
          return null
        } else {
          return parseInt(this.value)
        }
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },
  watch: {
  },
  created() {
    this.getTree()
  },
  mounted() {
  },
  methods: {
    init(list) {
      list.forEach((item) => {
        if (this.organType.indexOf(item.organType) < 0) {
          item.disabled = true
        }
        if (item.children && item.children.length > 0) {
          this.init(item.children)
        } else {
          delete item.children
        }
      })
    },
    getTree() {
      // 根据承建商获取组织
      if (this.busContractorId) {
        busContractorUserOrgan({
          busContractorId: this.busContractorId
        }).then((d) => {
          // console.log(d)
          const list = d.data
          this.init(list)
          this.options = list
          this.$emit('init', d.data)
        })
      } else {
        choseOrganOrganTreeData({
          filterOrganType: this.organType,
          filterOrganNature: this.organNature
        }).then((d) => {
          // console.log(d)
          const list = d.data
          this.init(list)
          this.options = list
          this.$emit('init', d.data)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
